import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const SellingSpotInput = ({ stores, control, search, setSearch }) => {
  const { t: translator } = useTranslation();

  return (
    <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
      <label htmlFor="ddlStore">{translator("POS-New_EditPOS-Store")}</label>{" "}
      {stores && (
        <Controller
          as={Select}
          options={
            stores &&
            stores.map((p) => ({
              id: p.id,
              label: p.name,
              value: p.id,
            }))
          }
          name="storeId"
          control={control}
          isDisabled={stores.length === 0}
          placeholder={translator("Select-Store")}
          onChange={function (event) {
            setSearch({ ...search, storeId: event[0].id });
            return event[0];
          }}
        />
      )}
    </div>
  );
};

export default SellingSpotInput;
